<template>
    <div class="wp">
        <div class="w-1200 company-detail-1">
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                    <el-breadcrumb-item :to="{path:'/home'}">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{path:'/companyCenter'}">企业中心</el-breadcrumb-item>
                    <el-breadcrumb-item>企业详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="box-bottom">
                <div class="b-b-1">
                    <div class="img">
                        <el-image style="width: 100%; height: 100%" :src="detail.pics" fit="contain">
                                <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                </div> -->
                        </el-image>
                    </div>
                    <div class="company">
                        <p class="p1 p-lv">
                            {{detail.companyname}}
                        </p>
                        <p class="p2">证件号码</p>
                        <p class="p3">{{detail.zjbh}}</p>
                        <p class="p2">营业执照号</p>
                        <p class="p3">{{detail.yyzzzh}}</p>
                        <p class="p2">联系电话</p>
                        <p class="p3">{{detail.lxdh}}</p>
                        <p class="p2">企业类别</p>
                        <p class="p3">{{detail.companytype}}</p>
                        <p class="p2">地址</p>
                        <p class="p3" style="width:calc(100% - 100px);">{{detail.addrComplete}}</p>
                    </div>
                    <div class="bussiness">
                        <p class="p1">主营</p>
                        <p class="p2">{{detail.cp}}</p>
                    </div>
                </div>
                <div class="b-b-2">
                    <div class="title-triangle">
                        <p class="t-t-t active">企业介绍</p>
                        <div class="triangle"></div>
                    </div>
                    <div class="box-bottom">
                        <div class="p-d">
                            <com-richtext :richtext="detail.gsjj"></com-richtext>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CompanyDetail from './CompanyDetail.js';
export default CompanyDetail;
</script>
<style lang="scss" scoped>
@import './CompanyDetail.scss';
</style>